import { Route, Switch, useRouteMatch } from "react-router-dom";
import React from "react";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import PublisherEdit from "../publishers/PublisherEdit";
import PublisherRegistrationsList from "./PublisherRegistrationsList";
function PublisherRegistration() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, component: PublisherRegistrationsList }),
        React.createElement(Route, { path: "".concat(cleanPath, "/approval/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherEdit, { status: "APPROVE" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/restore/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherEdit, { status: "RESTORE" }))); } })));
}
export default PublisherRegistration;
